var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupplier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_355_4722)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 48,
    height: 48,
    rx: 10,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 47,
    height: 47,
    rx: 9.5,
    stroke: "#EAECF0",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 35.75C20.07 35.75 15.25 30.93 15.25 25C15.25 19.07 20.07 14.25 26 14.25C31.93 14.25 36.75 19.07 36.75 25C36.75 25.41 36.41 25.75 36 25.75C35.59 25.75 35.25 25.41 35.25 25C35.25 19.9 31.1 15.75 26 15.75C20.9 15.75 16.75 19.9 16.75 25C16.75 30.1 20.9 34.25 26 34.25C26.41 34.25 26.75 34.59 26.75 35C26.75 35.41 26.41 35.75 26 35.75Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0002 34.75H22.0002C21.5902 34.75 21.2502 34.41 21.2502 34C21.2502 33.59 21.5702 33.26 21.9802 33.25C20.4102 27.89 20.4102 22.11 21.9802 16.75C21.5802 16.74 21.2502 16.41 21.2502 16C21.2502 15.59 21.5902 15.25 22.0002 15.25H23.0002C23.2402 15.25 23.4702 15.37 23.6102 15.56C23.7502 15.76 23.7902 16.01 23.7102 16.24C21.8302 21.89 21.8302 28.12 23.7102 33.77C23.7902 34 23.7502 34.25 23.6102 34.45C23.4702 34.65 23.2402 34.75 23.0002 34.75Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.46 25.75C30.05 25.75 29.71 25.41 29.71 25C29.71 22.02 29.2299 19.07 28.2899 16.24C28.1599 15.85 28.3699 15.4199 28.7599 15.2899C29.1499 15.1599 29.58 15.37 29.71 15.76C30.7 18.74 31.21 21.85 31.21 25C31.21 25.41 30.87 25.75 30.46 25.75Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 30.2101C23.2 30.2101 20.43 29.8101 17.75 29.0201C17.74 29.4201 17.41 29.7501 17 29.7501C16.59 29.7501 16.25 29.4101 16.25 29.0001V28.0001C16.25 27.7601 16.37 27.5301 16.56 27.3901C16.76 27.2501 17.01 27.21 17.24 27.29C20.07 28.23 23.02 28.7101 26 28.7101C26.41 28.7101 26.75 29.0501 26.75 29.4601C26.75 29.8701 26.41 30.2101 26 30.2101Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0002 22.7499C34.9202 22.7499 34.8402 22.7399 34.7602 22.7099C29.1102 20.8299 22.8802 20.8299 17.2302 22.7099C16.8402 22.8399 16.4102 22.6299 16.2802 22.2399C16.1502 21.8499 16.3602 21.4199 16.7502 21.2899C22.7102 19.2999 29.2702 19.2999 35.2202 21.2899C35.6102 21.4199 35.8202 21.8499 35.6902 22.2399C35.6102 22.5499 35.3102 22.7499 35.0002 22.7499Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2 35.15C30.02 35.15 28.25 33.38 28.25 31.2C28.25 29.02 30.02 27.25 32.2 27.25C34.38 27.25 36.15 29.02 36.15 31.2C36.15 33.38 34.38 35.15 32.2 35.15ZM32.2 28.75C30.85 28.75 29.75 29.85 29.75 31.2C29.75 32.55 30.85 33.65 32.2 33.65C33.55 33.65 34.65 32.55 34.65 31.2C34.65 29.85 33.55 28.75 32.2 28.75Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9999 35.75C35.8099 35.75 35.6199 35.68 35.4699 35.53L34.4699 34.53C34.1799 34.24 34.1799 33.7599 34.4699 33.4699C34.7599 33.1799 35.2399 33.1799 35.5299 33.4699L36.5299 34.4699C36.8199 34.7599 36.8199 35.24 36.5299 35.53C36.3799 35.68 36.1899 35.75 35.9999 35.75Z",
    fill: "#292D32"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_355_4722",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_355_4722"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_355_4722",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupplier);
export default __webpack_public_path__ + "static/media/supplier.0a50748622428254c18fc41c1c2f2fa6.svg";
export { ForwardRef as ReactComponent };